{
  "comment": "Corrects dimension references that do not match a published dimension. Kept as data so a newly discovered misspelling is an edit here rather than a release. Keys are compared after taking the last path segment, trimming, and lowercasing. Every entry below was observed in real data: 'susatinability' is live in the registry right now and reaches every report that checks containerisation; the other two appear in older reports and in a database patch carried by the previous dashboard.",
  "aliases": {
    "susatinability": "sustainability",
    "sustaintability": "sustainability",
    "sustaninability": "sustainability"
  }
}
